import React from "react";

const ContactUs = () => {
  return (
    <div>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d356.33520237207944!2d80.10315798806619!3d13.152354430467152!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a526386cd93f5df%3A0x76bf6d8d11be2bf1!2sBharath%20Computer!5e0!3m2!1sen!2sin!4v1658403702994!5m2!1sen!2sin"
        className=" w-full md:h-[40rem] h-[35rem]  "
      ></iframe>
    </div>
  );
};

export default ContactUs;
